// src/components/AnonymizationProfilesPage/CustomWordsSection.jsx
import React from 'react';
import {
    Box,
    Typography,
    TextField,
    Chip,
    Paper,
    InputAdornment,
    Button,
} from '@mui/material';
import { Add, Tag } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const CustomWordsSection = ({
    customWords,
    newWord,
    setNewWord,
    onChangeCustomWords,
}) => {
    const { t } = useTranslation();

    const addWord = () => {
        const trimmed = newWord.trim();
        if (!trimmed) return;
        onChangeCustomWords([...(customWords || []), trimmed]);
        setNewWord('');
    };

    const onKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            addWord();
        }
    };

    const deleteWord = (index) => {
        onChangeCustomWords(customWords.filter((_, i) => i !== index));
    };

    return (
        <Box
            sx={{
                p: 3,
                borderRadius: 3,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
            }}
        >
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
                {t('anonymizationProfiles.customWordsTitle', 'Vlastné slová na anonymizáciu')}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                {t('anonymizationProfiles.customWordsDesc', 'Pridajte špecifické slová alebo frázy, ktoré chcete vždy skryť.')}
            </Typography>

            <Box sx={{ display: 'flex', gap: 1.5, mb: 3 }}>
                <TextField
                    size="small"
                    placeholder={t('anonymizationProfiles.customWordsPlaceholder', 'Napr. tajný projekt Alfa')}
                    value={newWord}
                    onChange={(e) => setNewWord(e.target.value)}
                    onKeyDown={onKeyDown}
                    fullWidth
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Tag fontSize="small" color="action" />
                            </InputAdornment>
                        ),
                        sx: { borderRadius: 2 }
                    }}
                />
                <Button
                    variant="contained"
                    disableElevation
                    onClick={addWord}
                    disabled={!newWord.trim()}
                    sx={{ borderRadius: 2, px: 3 }}
                    startIcon={<Add />}
                >
                    {t('common.add', 'Pridať')}
                </Button>
            </Box>

            {/* chips container */}
            <Paper
                elevation={0}
                sx={{
                    p: 2,
                    borderRadius: 2,
                    bgcolor: 'action.selected',
                    border: '1px dashed',
                    borderColor: 'divider',
                    minHeight: 80,
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1,
                    alignItems: customWords && customWords.length ? 'flex-start' : 'center',
                    justifyContent: customWords && customWords.length ? 'flex-start' : 'center',
                }}
            >
                {!customWords || customWords.length === 0 ? (
                    <Typography
                        variant="body2"
                        color="text.disabled"
                    >
                        {t(
                            'anonymizationProfiles.customWordsEmpty',
                            'Zatiaľ žiadne vlastné slová. Zadajte ich vyššie.'
                        )}
                    </Typography>
                ) : (
                    customWords.map((word, index) => (
                        <Chip
                            key={`${word}-${index}`}
                            label={word}
                            onDelete={() => deleteWord(index)}
                            variant="outlined"
                            sx={{
                                borderRadius: '6px',
                                bgcolor: 'background.paper',
                                fontWeight: 500,
                            }}
                        />
                    ))
                )}
            </Paper>
        </Box>
    );
};

export default CustomWordsSection;